<template>
  <v-container fluid>
    <v-row class="d-flex flex-row">
      <v-col cols="12">
        <FormSeoConfig
          :data="seoConfig"
          :loading="isMutationLoading"
          :loadingData="isFormLoading"
          :isNew="!id"
          :language="language"
          @delete-seo-config="deleteSeoConfig"
          @language-update="language = $event"
          @submit="formSeoConfigSubmit"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmSeoConfigRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import FormSeoConfig from './form'
import ConfirmationDialog from '@/components/confirmation-dialog'
import seoConfigQuery from '@/services/gql/types/SeoConfigs/queries/seoConfig.gql'
import createSeoConfig from '@/services/gql/types/SeoConfigs/mutations/createSeoConfig.gql'
import deleteSeoConfig from '@/services/gql/types/SeoConfigs/mutations/deleteSeoConfig.gql'
import updateSeoConfig from '@/services/gql/types/SeoConfigs/mutations/updateSeoConfig.gql'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { getListWithNewMainLanguage, setTranslation } from '@/utils/locales'

export default {
  name: 'SeoConfig',
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    FormSeoConfig,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать конфигурацию seo' : 'Создать конфигурацию seo'
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      seoConfig: {}
    }
  },
  computed: {
    isFormLoading () {
      return this.$apollo.queries.seoConfig.loading
    },
    isMutationLoading () {
      return this.$async.createSeoConfig.$pending || this.$async.updateSeoConfig.$pending
    }
  },
  methods: {
    async formSeoConfigSubmit (seoConfigPayload) {
      if (!this.id) await this.createSeoConfig(seoConfigPayload)
      else await this.updateSeoConfig(seoConfigPayload)
    },
    async deleteSeoConfig () {
      try {
        await this.$refs.confirmSeoConfigRemoving.open()
        await this.$async.deleteSeoConfig.$perform({ id: Number(this.id) })
        this.$successMsg('Конфигурация SEO удалена')
      } catch (e) {
        this.$handleApiError(
          e,
          `Ошибка при удалении конфигурации SEO с ID ${this.id}`
        )
      } finally {
        await this.$router.push({ name: 'page-seo-configs' })
      }
    },
    async updateSeoConfig ({ data }) {
      try {
        setTranslation(data, this.language)
        await this.$async.updateSeoConfig.$perform(
          {
            id: Number(this.id),
            data
          },
          { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) }
        )
        this.$successMsg('Конфигурация SEO изменена')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при редактировании страницы')
      }
    },
    async createSeoConfig ({ data }) {
      // TODO
      delete data.translations

      try {
        await this.$async.createSeoConfig.$perform({
          data
        })
        this.$successMsg('Конфигурация SEO создана')
        await this.$router.push({ name: 'page-seo-configs' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании конфигурации SEO')
      }
    }
  },
  apollo: {
    seoConfig: {
      query: seoConfigQuery,
      fetchPolicy: 'network-only',
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: Number(this.id)
          }
        }
      },
      context () {
        return {
          headers: {
            Language: getListWithNewMainLanguage(this.language, contentLocalesValues())
          }
        }
      }
    }
  },
  async: {
    createSeoConfig (variables) {
      return this.$apollo.mutate({
        mutation: createSeoConfig,
        variables
      })
    },
    deleteSeoConfig (variables) {
      return this.$apollo.mutate({
        mutation: deleteSeoConfig,
        variables
      })
    },
    updateSeoConfig (variables, headers) {
      return this.$apollo.mutate({
        mutation: updateSeoConfig,
        variables,
        context: {
          headers
        }
      })
    }
  }
}
</script>
